import PropTypes from 'prop-types'
import { ProgressBarHeaderContainer } from '../styled-components'

const ProgressBarHeader = ({ hideLabel, children }) => {
  return (
    !hideLabel && (
      <ProgressBarHeaderContainer>{children}</ProgressBarHeaderContainer>
    )
  )
}

ProgressBarHeader.propTypes = {
  hideLabel: PropTypes.bool,
  children: PropTypes.node
}

export default ProgressBarHeader
